import React from "react";

const SvgTwitter = (props) => (
  <svg viewBox="0 0 30 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 21.1576C2.724 22.8554 5.958 23.8442 9.435 23.8442C20.757 23.8442 26.9475 14.7317 26.9475 6.8301C26.9475 6.57105 26.9415 6.31497 26.9295 6.05888C28.1325 5.21513 29.1765 4.16267 30 2.96365C28.8975 3.4403 27.711 3.76003 26.466 3.90214C27.7365 3.16645 28.71 1.99112 29.172 0.596712C27.9825 1.28059 26.664 1.77796 25.263 2.04589C24.141 0.885363 22.5405 0.160034 20.7705 0.160034C17.3715 0.160034 14.6145 2.83487 14.6145 6.13586C14.6145 6.60658 14.67 7.06102 14.775 7.49918C9.66 7.25049 5.1225 4.87023 2.0895 1.25247C1.56 2.13767 1.2555 3.16201 1.2555 4.25888C1.2555 6.33273 2.3415 8.16382 3.993 9.23553C2.9835 9.2074 2.0355 8.93651 1.2045 8.48799C1.2045 8.51316 1.2045 8.53832 1.2045 8.56349C1.2045 11.4589 3.3285 13.8776 6.141 14.4268C5.6265 14.5645 5.082 14.6355 4.521 14.6355C4.1235 14.6355 3.738 14.6 3.363 14.5289C4.1445 16.9062 6.4185 18.6352 9.111 18.6811C7.005 20.2857 4.3545 21.239 1.4685 21.239C0.972 21.239 0.483 21.2153 0 21.1576Z"
      fill="white"
    />
  </svg>
);

export default SvgTwitter;
